// src/App.js
import { BrowserRouter } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

// Layout
import MainLayout from "./layouts/MainLayout";
import { ScrollToTopAndTrack as ScrollToTop } from "./components/common";

// Routes
import AppRoutes from "./routes";

// Providers
import { AppDataProvider } from "./providers/AppDataProvider";

// Components
import { Loading } from "./components/common";
import Maintenance from "./components/Maintenance";
import useAppData from "./hooks/useAppData";

// Modals
import { ModalProvider, useModal } from "./context/ModalContext";
import RequestQuote from "./components/modals/RequestQuote";

// GA4
import ReactGA from "react-ga4";

ReactGA.initialize("G-V3C1K5X190");

function GlobalModals() {
	const { isQuoteOpen, closeQuote } = useModal();

	return <RequestQuote show={isQuoteOpen} onHide={closeQuote} />;
}

function AppContent() {
	const { loading, maintenance } = useAppData();

	if (maintenance) return <Maintenance />;
	if (loading) return <Loading />;

	return (
		<>
			<MainLayout>
				<ScrollToTop />
				<AppRoutes />
			</MainLayout>
			<GlobalModals />
		</>
	);
}

function App() {
	return (
		<BrowserRouter>
			<AppDataProvider>
				<ModalProvider>
					<AppContent />
				</ModalProvider>
			</AppDataProvider>
		</BrowserRouter>
	);
}

export default App;
